import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function FilterAll({ color = 'icon.primary', fill = 'transparent', ...props }) {
  return (
    <IconBase viewBox='0 0 21 21' {...props}>
      <Path
        d='M12.6875 11.8125L17.2436 7.25638C17.4081 7.09188 17.5 6.86962
         17.5 6.63775V4.375C17.5 3.892 17.108 3.5 16.625 3.5H4.375C3.892
          3.5 3.5 3.892 3.5 4.375V6.63775C3.5 6.86962 3.59188 7.09275
           3.75638 7.25638L8.3125 11.8125'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d='M8.3125 11.8125V17.2804C8.3125 17.9917 8.981 18.5141 9.67137
         18.3417L11.8589 17.7949C12.3454 17.6732 12.6875 17.2357 12.6875
          16.7335V11.8125'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
    </IconBase>
  )
}

FilterAll.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default FilterAll
